(() => {
  "use strict";

  const instances = new WeakMap();

  const init = (root) => {
    if (!root || instances.has(root)) return;

    const items = root.querySelectorAll("[data-wb-trust-icons-item]");
    if (!items.length) return;

    const reduceMotion = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduceMotion || !("IntersectionObserver" in window)) {
      items.forEach((item) => item.classList.add("is-visible"));
      instances.set(root, { destroy: () => {} });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -24px 0px"
      }
    );

    items.forEach((item) => observer.observe(item));

    instances.set(root, {
      destroy: () => {
        observer.disconnect();
        instances.delete(root);
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-wb-trust-icons]").forEach(init);
  };

  document.addEventListener("DOMContentLoaded", () => {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-wb-trust-icons]").forEach((root) => {
      const instance = instances.get(root);
      if (instance && typeof instance.destroy === "function") {
        instance.destroy();
      }
    });
  });
})();